/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import Navbar from "./Navbar"
import "./layout.css"
import { useStaticQuery, graphql } from "gatsby"

const Layout = ({ children, clickHandler }) => {

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  useEffect(() => {
    var bdy = document.getElementsByTagName('body')[0];
    if (contrast) {
      bdy.className = 'light';
    } else {
      bdy.className = '';
    }
  });

  const [contrast, setContrast] = useState(false);
  
  function setContrastOn(cc) {
    clickHandler(cc);
    setContrast(cc);
  }

  return (
    <>
        <Navbar siteTitle={data.site.siteMetadata?.title || `Title`} clickHandler={setContrastOn}/>
        <main>{children}</main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
